import React from 'react'

import { getClientApplication, getCollateralsAssets } from 'api/application'
import AutomobileApplicationForm from 'containers/ApplicationSubmissionForms/AutomobileApplication/AutomobileApplicationForm'
import convertAppValues from 'containers/ApplicationSubmissionForms/AutomobileApplication/convertAppValues'
import convertCollateralValues from 'containers/ApplicationSubmissionForms/AutomobileApplication/convertCollateralValues'
import { vehicleSelectionAutomobileFields } from 'form/fields'

import ReadOnlyWrapper from '../components/ReadOnlyWrapper'
import {
    useReadOnlyApplication,
    ApplicationStatusProps,
} from '../hooks/useReadOnlyApplication'
import { Container } from './AutomobileReadOnly.styled'

const getApplicationData = async (
    id: string,
    abortController: AbortController,
): Promise<{ appValues: object; app: ApplicationStatusProps }> => {
    const app = await getClientApplication(id, abortController)
    const appValues = convertAppValues(app)
    const collaterals = await getCollateralsAssets(app.uuid, abortController)
    const collateralValues = convertCollateralValues(collaterals)

    if (collateralValues) {
        return {
            appValues: {
                ...appValues,
                vehicle: {
                    ...vehicleSelectionAutomobileFields.config.initialValue,
                    ...collateralValues,
                },
            },
            app,
        }
    }

    return {
        appValues,
        app,
    }
}

export default function AutomobileReadOnly() {
    const { id, error, loading, appData, appStatus, applicantName } =
        useReadOnlyApplication(getApplicationData)

    return (
        <Container>
            <ReadOnlyWrapper
                loading={loading}
                error={error}
                appStatus={appStatus}
                applicantName={applicantName}
                id={id}
            >
                <AutomobileApplicationForm
                    isReadOnly
                    isLoading={loading}
                    overrideDefaultInitialValues={appData}
                />
            </ReadOnlyWrapper>
        </Container>
    )
}
